import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from '../../../reducers/common.reducer';
import { getResultsForSingleAgentService, updateRemainBalanceService } from '../../../services/result.service';
import { getSharePercentByGameTypeService } from '../../../services/sharepercent.service';

const Copier = ( props ) => {
    const { isSaveFormVisible, onClick, startDate, endDate, gameTypeDetailData, fromDateToDate } = props;
    const [sharePercent, setSharePercent] = useState();
   
    let dispatch = useDispatch()
 
    async function getSharePercent () {   
        try {
            dispatch(setIsLoading(true))
            let result = await getSharePercentByGameTypeService({startDate,endDate},gameTypeDetailData.gameTypeId , "0c09fb75-72d5-428d-917c-c6358f139de6" )
            if(result.data) {
            setSharePercent(result.data)
            }
        }
        catch (error) {
            dispatch(
                setToastMessage({
                message: error?.response?.data?.message || error?.message,
                type: "error",
                })
            );
        }
        finally {
            dispatch(setIsLoading(false))
        }
    }

    useEffect(()=> {
     getSharePercent();

    }, [startDate, endDate, gameTypeDetailData]);
   
   
//   async function updateRemain ( ) {
   
//     try {
//         dispatch(setIsLoading(true));
    
//         let result = await updateRemainBalanceService(  );
        
//         if(result.data){
//             dispatch(
//                 setToastMessage({
//                 message: "Success",
//                 type: "success",
//                 })
//             );
//         }
//      }

//      catch (error) {
//         dispatch(
//             setToastMessage({
//             message: error?.response?.data?.message || error?.message,
//             type: "error",
//             })
//         );
//     } 

//     finally
//      {
//         dispatch(setIsLoading(false))
//      }
//   }

    // Helper to format currency
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        }).format(amount);
    };

    return (
        <>
            {/* Overlay - optional, if you want to click outside to close, you can add an overlay div here 
                For now, we just stick to the drawer itself as requested, but cleaner.
            */}
            <div 
                onClick={(e) => e.stopPropagation()}
                className={`fixed top-0 right-0 h-full w-full max-w-lg z-50 bg-white shadow-2xl transform transition-transform duration-300 ease-in-out flex flex-col
                ${isSaveFormVisible ? 'translate-x-0' : 'translate-x-full'}`
            }>
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-5 border-b border-borderColor bg-white">
                    <div>
                        <h2 className="text-xl font-bold text-gray-800">Share Distribution</h2>
                        {fromDateToDate && (
                            <p className="text-sm text-fgColor mt-1">{fromDateToDate}</p>
                        )}
                    </div>
                    <button 
                        onClick={onClick}
                        className="p-2 rounded-full hover:bg-gray-100 transition-colors duration-200"
                        aria-label="Close"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-500">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto p-6">
                    
                    {/* Summary Cards */}
                    <div className="grid grid-cols-2 gap-4 mb-8">
                        <div className="bg-bgColor p-4 rounded-xl">
                            <p className="text-sm font-medium text-fgColor mb-1">Game Type</p>
                            <p className="text-lg font-bold text-gray-800">{gameTypeDetailData?.gameType}</p>
                        </div>
                        <div className="bg-bgColor p-4 rounded-xl">
                            <p className="text-sm font-medium text-fgColor mb-1">Total Win/Loss</p>
                            <p className={`text-lg font-bold ${parseFloat(gameTypeDetailData?.total) < 0 ? 'text-attractive2' : 'text-attractive1'}`}>
                                {formatCurrency(gameTypeDetailData?.total)}
                            </p>
                        </div>
                    </div>
              
                    {/* Table */}
                    <div className="overflow-hidden border border-borderColor rounded-lg">
                        <table className="w-full text-left border-collapse">
                            <thead className="bg-bgColor">
                                <tr>
                                    <th className="px-4 py-3 text-xs font-semibold text-fgColor uppercase tracking-wider">User</th>
                                    <th className="px-4 py-3 text-xs font-semibold text-fgColor uppercase tracking-wider text-center">Percent</th>
                                    <th className="px-4 py-3 text-xs font-semibold text-fgColor uppercase tracking-wider text-right">Win/Loss Amt</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-borderColor bg-white">
                                {!!sharePercent && sharePercent?.map((result) => {
                                    const amount = (result?.percent / 100) * 1 * gameTypeDetailData.total;
                                    return (
                                        <tr key={result.id} className="hover:bg-gray-50 transition-colors">
                                            <td className="px-4 py-3 text-sm font-medium text-gray-700">{result?.name}</td>
                                            <td className="px-4 py-3 text-sm text-gray-600 text-center">{result?.percent}%</td>
                                            <td className={`px-4 py-3 text-sm font-semibold text-right ${amount < 0 ? 'text-attractive2' : 'text-attractive1'}`}>
                                                {formatCurrency(amount)}
                                            </td>
                                        </tr>
                                    )
                                })}
                                {(!sharePercent || sharePercent.length === 0) && (
                                    <tr>
                                        <td colSpan="3" className="px-4 py-8 text-center text-gray-500">
                                            No share data available.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Copier
